import { render, staticRenderFns } from "./details-1.vue?vue&type=template&id=5a93fa48&scoped=true&"
import script from "./details-1.vue?vue&type=script&lang=js&"
export * from "./details-1.vue?vue&type=script&lang=js&"
import style0 from "./details-1.vue?vue&type=style&index=0&id=5a93fa48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a93fa48",
  null
  
)

export default component.exports